import * as React from 'react'
import CIcon from '@coreui/icons-react'
import { cilCheckCircle, cilMinus } from '@coreui/icons'
import "./style.css"

export default function TextRemove({ name, placeholder, inputProps }) {
    const [showPassword, setShowPassword] = React.useState(false)
    const handleClickShowPassword = () => {
        setShowPassword((show) => !show)


        const prevValues = inputProps?.value;
        const indexRemove = prevValues?.indexOf("_remove")
        if (indexRemove === -1)
            inputProps.onChange(`${inputProps?.value}_remove`)
        if (indexRemove !== -1) {
            var dataTanpaUnderscore = prevValues.replace("_remove", "")
            inputProps.onChange(`${dataTanpaUnderscore}`)
        }



    }

    // React.useEffect(() => {

    // }, [inputProps?.value])



    return (
        <div className="input-group mb-3 input-wrapper">
            <style jsx="true">
                {`
                    .input-remove {
                        width: 100%;
                        text-decoration: line-through;
                        font-style: italic;
                        /* Garis tengah untuk teks value */
                        box-sizing: border-box;
                        outline: none;
                        /* Menghilangkan tampilan garis fokus default */
                    }
                    
                `}
            </style>
            <input
                type="text"
                className={showPassword ? "form-control form-control-sm input-remove" : "form-control form-control-sm"}
                placeholder={placeholder}
                aria-label={placeholder}
                aria-describedby="basic-addon2"
                name={name}
                {...inputProps}
                disabled={showPassword}
            />
            <button
                className={showPassword ? "btn btn-sm btn-primary" : "btn btn-sm btn-danger"}
                id="basic-addon2"
                type="button"
                onClick={handleClickShowPassword}
            >
                {showPassword ? <CIcon icon={cilCheckCircle} /> : <CIcon icon={cilMinus} />}
            </button>
        </div>
    )
}
